import { render, staticRenderFns } from "./OnetimePaymentCell.vue?vue&type=template&id=6e24675c&scoped=true"
import script from "./OnetimePaymentCell.vue?vue&type=script&lang=js"
export * from "./OnetimePaymentCell.vue?vue&type=script&lang=js"
import style0 from "./OnetimePaymentCell.vue?vue&type=style&index=0&id=6e24675c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e24675c",
  null
  
)

export default component.exports